module.exports = __webpack_public_path__ + "img/Avatar-1.05c1bfc4.gif";